import React, { useEffect } from "react";
import { MenuCategory, appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { useStyles } from "./useStyles";
import { MenuItemCard } from "../MenuItemCard";
import { Subtitle2 } from "@fluentui/react-components";

interface MenuCategoryProps {
  category: MenuCategory;
  headingId?: string;
}

export const MenuCategoryCard = ({ category, headingId }: MenuCategoryProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "MenuCategoryCard",
      category: category.name,
    });
  }, [appInsights, context, category.name]);

  return (
    <div className={styles.container} data-testid="menuCategoryCard">
      <Subtitle2 as="h2" id={headingId} className={styles.categoryHeader}>
        {category.name}
      </Subtitle2>
      <div
        className={styles.menuItemsContainer}
        role="list"
        aria-label={`${category.name} menu items`}
      >
        {category?.items?.map((item) => {
          return (
            <div className={styles.menuItemContainer} role="listitem" key={item.id}>
              <MenuItemCard menuItem={item} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
